import {inject, customElement, bindable, bindingMode, LogManager} from 'aurelia-framework';
import {EventAggregator, Subscription} from 'aurelia-event-aggregator';
import {GroupService} from '../../../../../services/group/group-service';
import {RequestAffiliationEvent} from '../../../../../broadcast/group-events';
import {map} from 'lodash';

const logger = LogManager.getLogger('GroupAffiliation');

@inject(GroupService, EventAggregator)
@customElement('group-affiliation')
export class GroupAffiliation {

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) groupId = -1;

  groupList = [];
  selectedGroups = [];
  requesting = false;
  visible = false;
  private __subscription: Subscription;

  constructor(private __groupService: GroupService, private __ea: EventAggregator) {
  }

  bind() {
    this.__subscription = this.__ea.subscribe(RequestAffiliationEvent, msg => {
      if (this.groupId !== msg.groupId) {
        this.groupId = msg.groupId;
      } else {
        this.groupIdChanged(this.groupId);
      }
    });
  }

  unbind() {
    this.__subscription.dispose();
  }

  groupIdChanged(value) {
    return this.__groupService.affiliationCandidates(+value)
      .response.then(list => {
        this.groupList = list;
        this.visible = true;
      }).catch(e => logger.error(e));
  }

  requestAffiliation() {
    if (this.selectedGroups.length && !this.requesting) {
      this.requesting = true;
      this.__groupService.requestAffiliation(this.groupId, this.selectedGroups)
        .finally(() => {
          this.requesting = false;
          this.close();
        });
    }
  }

  close() {
    this.visible = false;
    this.groupList = [];
    this.selectedGroups = [];
  }

  checkAll() {
    this.selectedGroups = map(this.groupList, g => g.id);
  }

  uncheckAll() {
    this.selectedGroups = [];
  }

}
